/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RefundsService {
    /**
     * Create Request
     * @param serviceRequestId
     * @param adminId
     * @param reason
     * @param notes
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createRequestRefundsRequestPost(
        serviceRequestId: number,
        adminId: number,
        reason?: string,
        notes?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refunds/request',
            query: {
                'service_request_id': serviceRequestId,
                'admin_id': adminId,
                'reason': reason,
                'notes': notes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Refund
     * @param refundId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRefundRefundsRefundIdGet(
        refundId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/refunds/{refund_id}',
            path: {
                'refund_id': refundId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Refunds
     * @param serviceRequestId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listRefundsRefundsGet(
        serviceRequestId?: (number | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/refunds',
            query: {
                'service_request_id': serviceRequestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Summary
     * @param serviceRequestId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static summaryRefundsSummaryServiceRequestIdGet(
        serviceRequestId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/refunds/summary/{service_request_id}',
            path: {
                'service_request_id': serviceRequestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Calculate
     * @param refundId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static calculateRefundsRefundIdCalculatePost(
        refundId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refunds/{refund_id}/calculate',
            path: {
                'refund_id': refundId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Override
     * @param refundId
     * @param amount
     * @param notes
     * @returns any Successful Response
     * @throws ApiError
     */
    public static overrideRefundsRefundIdOverridePost(
        refundId: number,
        amount: number,
        notes?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refunds/{refund_id}/override',
            path: {
                'refund_id': refundId,
            },
            query: {
                'amount': amount,
                'notes': notes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Initiate
     * @param refundId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static initiateRefundsRefundIdInitiatePost(
        refundId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refunds/{refund_id}/initiate',
            path: {
                'refund_id': refundId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
